<div class="container mt-5">
  @if (hasApiError) {
    <div class="alert alert-danger" role="alert">
      {{apiError}}
    </div>
  }
  <pre>
    <!-- <code class="js rounded" [highlight]="responseJson"></code> -->
    <code class="js rounded">{{responseJson}}</code>
  </pre>

</div>